import React, { useState, useEffect } from 'react';

import FootballPredictorNormalSize from './normalSize';
import FootballPredictorSmallSize from './smallSize';

export default function FootballPredictor() {
  const [windowSize, setWindowSize] = useState([
    window.innerWidth,
  ]);

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth]);
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return windowSize[0] > 767 ? <FootballPredictorNormalSize/> : <FootballPredictorSmallSize/>;
}